<template>
  <div>

    <main>
      <pricing-grid/>
    </main>

    <footerComponent></footerComponent>
  </div>
</template>

<script>
import footerComponent from "@/components/footerComponent.vue";
import monthlySwitcher from "@/components/monthlySwitcher.vue";
import roomInfoScreen from "@/components/roomInfoScreen.vue";
import PricingGrid from "../components/PricingGrid.vue";

export default {
  name: "userPlan",

  components: {
    PricingGrid,
    footerComponent,
    monthlySwitcher,
    roomInfoScreen,
  },

  mounted() {
  },

  data() {
    return {
      monthly: false,
      billing_plans: null,
    };
  },

  computed: {
    billing() {
      return {
        isLoading: this.$store.state.billing.isLoading,
        subscription: this.$store.state.billing.subscription,
        products: this.$store.state.billing.products,
      };
    },
  },

  methods: {
    isCurrentPlan(planId) {
      if (planId === "free") {
        return (
            this.billing.subscription.status === "deleted" || this.billing.subscription.planId === "free"
        );
      } else {
        return this.billing.subscription?.planId === planId.toString();
      }
    },

    listenSwitcher(switcherMonthly) {
      this.monthly = switcherMonthly;
    },

    async checkout(plan) {
      let planId = this.monthly ? plan.monthly.id : plan.yearly.id;
      await this.$store.dispatch("checkout", planId);
    },
  },
};
</script>

<style lang="scss" scoped>
.back_bth {
  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
  letter-spacing: normal;
  line-height: 24px;
  text-align: left;
  margin-bottom: 64px;
  display: flex;
  align-items: center;

  img {
    margin-right: 16px;
    height: 22px;
  }

  @media all and (max-width: 767px) {
    display: none;
  }
}
</style>
